"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var template = require("@reverbdotcom/url-template");
var classNames = require("classnames");
var elog = require("../../elog");
var lodash_1 = require("lodash");
var core_link_1 = require("../../components/core_link");
var url_helpers_1 = require("../../url_helpers");
var curatedSetLinkParams = template.parse('{?product_type}{&category}');
var COMPONENT_NAME = 'CuratedSetCard';
exports.BASIC_TILE = 'basicTile';
exports.FEATURE_TILE = 'featureTile';
exports.TWO_IMAGE_TILE = 'twoImageTile';
exports.CURATED_SET_TYPES = [
    exports.BASIC_TILE,
    exports.FEATURE_TILE,
    exports.TWO_IMAGE_TILE,
];
var CuratedSetCard = /** @class */ (function (_super) {
    tslib_1.__extends(CuratedSetCard, _super);
    function CuratedSetCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CuratedSetCard.prototype.getHref = function () {
        var params = {
            product_type: this.props.rootCategorySlug,
            category: this.props.leafCategorySlug,
        };
        return this.props.curatedSet.webLink.href + curatedSetLinkParams.expand(params);
    };
    CuratedSetCard.prototype.getBackgroundImageStyle = function () {
        var src = this.props.bannerOverride ?
            url_helpers_1.imageUploadURL(this.props.bannerOverride) :
            lodash_1.get(this.props.curatedSet.images[0], 'source');
        if (!src)
            return null;
        return { backgroundImage: "url(" + src + ")" };
    };
    CuratedSetCard.prototype.getClasses = function () {
        return classNames('curated-set-card', { 'curated-set-card--placeholder': !this.props.curatedSet }, { 'curated-set-card--basic': !this.props.displayAs || this.props.displayAs === exports.BASIC_TILE }, { 'curated-set-card--two-image': this.props.displayAs === exports.TWO_IMAGE_TILE }, { 'curated-set-card--feature': this.props.displayAs === exports.FEATURE_TILE });
    };
    CuratedSetCard.prototype.renderSquareImage = function () {
        if (this.props.displayAs !== exports.TWO_IMAGE_TILE)
            return;
        return (React.createElement("div", { className: "curated-set-card__square-image" },
            React.createElement("div", { className: "curated-set-card__square-image__inner", style: { backgroundImage: "url(" + url_helpers_1.imageUploadURL(this.props.squareImage) + ")" } })));
    };
    CuratedSetCard.prototype.renderPlaceholderCard = function () {
        return (React.createElement("div", { className: this.getClasses() },
            React.createElement("a", { href: "#" },
                React.createElement("div", { className: "curated-set-card__image" },
                    React.createElement("div", { className: "curated-set-card__image__inner" })),
                React.createElement("div", { className: "curated-set-card__text" },
                    React.createElement("div", { className: "curated-set-card__text__inner" },
                        this.renderSquareImage(),
                        React.createElement("div", { className: "curated-set-card__text__title" }))))));
    };
    CuratedSetCard.prototype.renderCount = function () {
        // needs implementation
        return false;
        return (React.createElement("small", null, "100 Listings"));
    };
    CuratedSetCard.prototype.render = function () {
        try {
            if (!this.props.curatedSet) {
                return this.renderPlaceholderCard();
            }
            return (React.createElement("div", { className: this.getClasses() },
                React.createElement(core_link_1.default, { to: this.getHref(), entityId: this.props.curatedSet.id, position: this.props.position },
                    React.createElement("div", { className: "curated-set-card__image" },
                        React.createElement("div", { className: "curated-set-card__image__inner", style: this.getBackgroundImageStyle() })),
                    React.createElement("div", { className: "curated-set-card__text" },
                        React.createElement("div", { className: "curated-set-card__text__inner" },
                            this.renderSquareImage(),
                            React.createElement("div", { className: "curated-set-card__title" },
                                this.props.titleOverride || this.props.curatedSet.title,
                                this.renderCount()))))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    return CuratedSetCard;
}(React.Component));
exports.default = CuratedSetCard;
//# sourceMappingURL=curated_set_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/curated_set_card.js
// module id = wBWj
// module chunks = 0 2 6 20